import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import createLocation from 'utils/createLocation';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { getContentItemIconFromType } from 'utils/icons';
import getContentProgress from 'utils/asset/getContentProgress';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import { TinyHorizontalCard, TypeIcon } from 'components/ContentCards';
import ContentProgressCircle from 'components/ContentProgressCircle';
import InlineList from 'components/InlineList';
import EmptyStateController from 'components/EmptyStateController';
import RelatedSkillContentButton from './RelatedSkillContentButton';
function SkillContentList(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    skillName = _ref.skillName,
    isLoading = _ref.isLoading,
    isError = _ref.isError,
    _ref$linkedContent = _ref.linkedContent,
    linkedContent = _ref$linkedContent === void 0 ? [] : _ref$linkedContent;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var pathname = location.pathname;
  var isEmpty = linkedContent.length === 0;
  return /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    isEmpty: isEmpty,
    emptyContent: /*#__PURE__*/React.createElement(Landmark, {
      height: 100
    }, /*#__PURE__*/React.createElement(Stack, {
      spacing: "s"
    }, /*#__PURE__*/React.createElement(Text, {
      dimmed: true
    }, t('empty_no_recommended_content_for_skill')), /*#__PURE__*/React.createElement(RelatedSkillContentButton, {
      name: skillName
    })))
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs",
    as: "list"
  }, linkedContent.map(function (content) {
    var id = content.id,
      name = content.name,
      thumbnailId = content.thumbnailId,
      userScormAssetStatus = content.userScormAssetStatus,
      userContentStatus = content.userContentStatus,
      completionRate = content.completionRate;
    var rawType = getContentItemType(content);
    var icon = getContentItemIconFromType(rawType);
    var type = t(getContentItemTypeTranslationKey(rawType));
    var isPlaylist = rawType === 'playlist';
    var progress = getContentProgress({
      isPlaylist: isPlaylist,
      userContentStatus: userContentStatus || 'notstarted',
      userScormAssetStatus: userScormAssetStatus,
      completionRate: completionRate || 0
    });
    var link = isCurrentUser ? isPlaylist ? "/playlists/".concat(id) : createLocation(pathname, {
      asset: id
    }) : undefined;
    return /*#__PURE__*/React.createElement(TinyHorizontalCard, {
      key: id,
      title: name,
      link: link,
      isImageLeft: true,
      imageSource: getPictureUrl({
        id: thumbnailId,
        dimensions: DIMENSIONS.TINY_CARD
      }),
      icon: isPlaylist ? 'playlist' : icon,
      subtitle: /*#__PURE__*/React.createElement(InlineList, {
        splitBy: "dot",
        display: "inline-flex",
        alignItem: "center"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TypeIcon, {
        name: icon
      }), type), /*#__PURE__*/React.createElement(ContentProgressCircle, {
        contentName: name,
        progress: progress,
        infoReadout: "short",
        scale: 4 / 6
      }))
    });
  })));
}
export default SkillContentList;